import styled from "styled-components";
import { Heading1, SubHeading } from "../../../../common/styled-components/styled-components";
import { breakpoints, device } from '../../../../../../app/js/utils/responsive_utilities';
import { white, whiteLilac, black, royal, PaleNavy } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';
import { bounceAnimation } from "../../../../common/functions/animations";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${white};
  ${styledFont("Graphie")}
  padding: 0.75rem 0 3rem 0;

  @media ${device.Desktop}{
    padding: 1rem 0 7rem 0;
  }
`

export const KidSafe = styled.div`
  width: 7.4rem;
  height: 2.7rem;
  margin: auto;
  > img{
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${breakpoints.md}px) {
    > img{
      width: 9.5rem;
      height: 3.4rem;
    }
  }
`

export const HeadingText = styled(Heading1)`
  color: ${black};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)}

  @media ${device.Desktop}{
    ${styledFont("Graphie", 4, 4.8, 7)}
  }
`

export const SubHeadingText = styled(SubHeading)`
  width: 80%;
  color: ${black};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 1.6, 2, 6)}

  @media ${device.Desktop}{
    ${styledFont("Graphie", 2, 2.4, 6)}
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${whiteLilac};
  font-family: Graphie;
  width: 100%;
  margin: auto;
  justify-content: space-around;
  padding: 11.6rem 0 6rem 0;
  position: relative;

  @media ${device.Desktop}{
    padding: 6.3rem 0 6rem 0;
  }

  .slider-wrapper .slick-slide{
    margin-right: 1.6rem;
    height: 28rem;
    width: 24.2rem;
    & > div {
      height: 100%;
    }

    @media ${device.Desktop}{
      width: 27rem;
      height: 38.5rem;
      margin-right: 3rem;
    }
  }

  .slider-wrapper .slick-slide.slick-center{
    height: 34rem;
    width: 26rem;
    @media ${device.Desktop}{
      width: 37rem;
      height: 40.7rem;
    }
  }

  .slider-wrapper .slick-track{
    display: flex;
    justify-content: center;
    align-items: center;
  }


  @media ${device.Desktop}{
    width: 73%;
  }
`;

export const InfoWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background : ${royal};
  border-radius: 0.8rem;
  justify-content: space-around;
  box-sizing: border-box;
  background: ${PaleNavy};
  padding: 1.6rem 2rem 3.2rem;
  box-sizing: border-box;
  color: ${black};
  &:not(:last-child) {
    margin-bottom: 1.2rem;
  }
  @media (min-width: ${breakpoints.md}px) {
    padding: 1.6rem 4.8rem 4.9rem

  }

  @media ${device.Desktop}{
    padding: 3.8rem 3.4rem 5.1rem
  }
`;

export const InfoTitle = styled.p`
  font-style: italic;
  ${styledFont("Graphie", 1.8, 2.4, 6)}
  margin: 2rem 0 .5rem;
  height: 70%;

  @media ${device.Desktop}{
    ${styledFont("Graphie", 2.4, 3.8, 6)}
  }
`;

export const InfoDetails = styled.div`
  @media (min-width: ${breakpoints.md}px) {
    width: 21rem;
  }
`;

export const InfoItem = styled.div`
  height: 20%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  @media (min-width: ${breakpoints.md}px) {
    width: 27rem;
  }
`;

export const InfoName = styled.p`
  margin: 0;
  ${styledFont("Graphie", 1.4, 1.6, 7)}
  margin-bottom: 0.4rem;
`;

export const InfoIcon = styled.div`
  width: 4.8rem;
  height: 4.8rem;
  margin-right: .7rem;
  img{
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: .1rem solid #BDBEFF;
  }
  @media (min-width: ${breakpoints.md}px) {
    margin-right: 1.4rem;
  }
`;

export const InfoDesignation = styled.p`
  margin: 0;
  ${styledFont("Graphie", 1.4, 1.6, 6)}
`

export const QuotesIcon = styled.div`
  position: absolute;
  top: 5%;
  right: 6%;

  @media (min-width: ${breakpoints.md}px){
    top: 11%;
    right: 5%;
  }

  @media ${device.Desktop}{
    top: 0%;
    right: -2%;
  }

`

export const KajuIcon = styled.div`
  position: absolute;
  bottom: 2.3rem;
  right: 13%;
  z-index: 2;
  animation: ${bounceAnimation(0.5)} 2s ease infinite;
  animation-delay : ${props=>props.delay};

  >img{
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${breakpoints.md}px) {
    right: 24%;
  }
  @media ${device.Desktop}{
    right: 31%;
    width: 11.5rem;
    height: 8.1rem;
  }
`

export const BlockIcon = styled.div`
  position: absolute;
  top: 7.4rem;
  left: 13%;
  z-index: 2;
  animation: ${bounceAnimation(0.5)} 2s ease infinite;
  animation-delay : ${props=>props.delay};

  >img{
    width: 100%;
    height: 100%;
  }
  @media (min-width: ${breakpoints.md}px) {
    left: 22%;
  }

  @media ${device.Desktop}{
    left: 31%;
    width: 7.9rem;
    height: 8rem;
    top: 3%;
  }
`
